import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_s8nt9uryvz: FaireBrandEntity = {
  token: "b_s8nt9uryvz",
  type: "brand",
  name: "Rekurator",
  avatarUrl:
    "https://cdn.faire.com/fastly/cbb620b8417a6ea5a5d3545e7e68ce088d74d2bc528f7665dbb99711d8b52b01.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/0649e3c3b2d94f5ef54ff948b00cbc3aa52ef56868d839ca695d46ce8de97026.png",
  logoUrl:
    "https://cdn.faire.com/fastly/cbb620b8417a6ea5a5d3545e7e68ce088d74d2bc528f7665dbb99711d8b52b01.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0649e3c3b2d94f5ef54ff948b00cbc3aa52ef56868d839ca695d46ce8de97026.png",
  location: "Chino Hills, CA, USA",
  minimumOrderDollars: 100,
  rating: 0,
  reviewCount: 0,
  isInsider: false,
  description:
    "REKURATOR was created with a simple belief: sustainable living should be easy, thoughtful, and enjoyable. At REKURATOR, we carefully curate products that help reduce waste while still being pleasant and practical to use. Every item we create or select meets high standards—prioritizing materials that are reusable, recyclable, compostable, or biodegradable. Even our shipping materials are chosen with care, using recycled or plastic-free packaging whenever possible.  Our mission is to help you create a more eco-friendly home through simple, thoughtful swaps. As a proud member of 1% for the Planet, we donate 1% of annual sales to environmental nonprofits. Together, small choices can create meaningful change.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:27.399Z",
    importedBy: "entity-db-cli",
  },
};
